/* Free 5-day sample page: claim flow, sticky bar, announcement text.
   Loaded only by snippets/da-sample-claim.liquid (template product.free-sample).
   Build log and decisions: active/free-sample-funnel-2026-09-16/README.md

   Claim flow:
     button -> Storefront API cart with 1 sample and TASTEJOY -> checkout.
   Email capture happens in Shopify checkout. */
(function () {
  'use strict';

  var configEl = document.getElementById('DaSampleConfig');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  /* ---------- Announcement bar ----------
     The header's announcement bar is global and promotes the main product. On this
     page it is swapped for the sample promise. da-sample.css hides the global text
     until this runs, so the old message never flashes. */
  function swapAnnouncement() {
    var bars = document.querySelectorAll('.utility-bar .announcement-bar');
    bars.forEach(function (bar) {
      var replacement = document.createElement('div');
      replacement.className = 'announcement-bar da-sample-announce';
      replacement.setAttribute('role', 'region');
      replacement.setAttribute('aria-label', 'Announcement');
      var p = document.createElement('p');
      p.className = 'announcement-bar__message h5';
      p.textContent = config.shipping
        ? 'Free 5-day sample. Just pay ' + config.shipping + ' shipping.'
        : 'Free 5-day sample.';
      replacement.appendChild(p);
      bar.replaceWith(replacement);
    });
  }

  /* ---------- Storefront API cart ---------- */
  function createCart() {
    var query =
      'mutation DaSampleCart($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    cart { checkoutUrl }' +
      '    userErrors { code message }' +
      '  }' +
      '}';

    var variables = {
      input: {
        lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + config.variantId, quantity: 1 }],
        discountCodes: [config.code],
        buyerIdentity: { countryCode: 'US' }
      }
    };

    return fetch(config.storefrontApi, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var payload = json && json.data && json.data.cartCreate;
        if (payload && payload.cart && payload.cart.checkoutUrl) {
          return { url: payload.cart.checkoutUrl };
        }
        var errors = (payload && payload.userErrors) || [];
        var soldOut = errors.some(function (err) {
          return /MERCHANDISE_NOT_ENOUGH_STOCK|MERCHANDISE_OUT_OF_STOCK|INVALID_MERCHANDISE_LINE/.test(err.code || '');
        });
        return { soldOut: soldOut };
      });
  }

  function fallbackUrl() {
    return '/cart/' + config.variantId + ':1?discount=' + encodeURIComponent(config.code);
  }

  /* ---------- Form ---------- */
  function bindForm(form) {
    var button = form.querySelector('[data-da-sample-submit]');
    var error = form.querySelector('.da-sample-form__error');
    var busy = false;

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
    }

    function clearError() {
      error.hidden = true;
      error.textContent = '';
    }

    function setBusy(state) {
      busy = state;
      button.disabled = state;
      form.classList.toggle('is-busy', state);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;

      clearError();
      setBusy(true);

      createCart().catch(function () { return {}; })
        .then(function (cart) {
          if (cart.url) {
            window.location.assign(cart.url);
            return;
          }
          if (cart.soldOut) {
            setBusy(false);
            showError('The free samples have all been claimed.');
            return;
          }
          window.location.assign(fallbackUrl());
        });
    });
  }

  /* ---------- Scroll-to-claim buttons (band CTA, sticky bar) ---------- */
  function focusClaim() {
    var box = document.getElementById('DaSampleClaim');
    if (!box) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = box.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- Sticky bar (mobile) ----------
     Shows once the claim form has scrolled above the viewport, hides while the form
     or the bottom banner button is on screen, so there is one claim button in view.

     Scroll position, not IntersectionObserver: a jump from the bottom of the page to
     the top moves the form from "above" to "below" without ever intersecting, so an
     observer never fires and the bar stayed up over the hero. Two rect reads per
     animation frame is cheap. */
  function bindSticky() {
    var bar = document.querySelector('[data-da-sample-sticky]');
    var form = document.querySelector('[data-da-sample-form]');
    if (!bar || !form) return;

    var band = document.querySelector('[data-da-sample-band-cta]');
    var shown = null;
    var queued = false;

    function render() {
      queued = false;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var formAbove = form.getBoundingClientRect().bottom < 0;
      var bandVisible = false;
      if (band) {
        var r = band.getBoundingClientRect();
        bandVisible = r.top < viewport && r.bottom > 0;
      }
      var show = formAbove && !bandVisible;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(render);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    render();
  }

  /* ---------- Header button ----------
     The mobile header's "Shop Now" pill links to the 50-count product. On this page it
     becomes "Claim Sample" and scrolls to the claim form instead. */
  function swapHeaderButton() {
    document.querySelectorAll('.da-header-shop').forEach(function (link) {
      link.textContent = 'Claim Sample';
      link.setAttribute('href', '#DaSampleClaim');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        focusClaim();
      });
    });
  }

  function init() {
    swapAnnouncement();
    swapHeaderButton();
    document.querySelectorAll('[data-da-sample-form]').forEach(bindForm);
    document.querySelectorAll('[data-da-sample-scroll]').forEach(function (el) {
      el.addEventListener('click', focusClaim);
    });
    bindSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
